import * as React from "react";
import { Table} from "antd";
import { connect } from "react-redux";
//import moment from "moment";

interface IUserlistProps {
  id:any;
  userlist:any;
}

// 修改
class Userlist extends React.Component<IUserlistProps, any> {
  state = {
     list:[]
  };
  constructor(props: IUserlistProps) {
    super(props);
  }

  componentDidMount() {
    this.userlist();     
  }

  userlist = () =>{
    const param: any = {
      id: this.props.id
    }; 
    this.props.userlist({
      ...param,
      callback: (data) => {
        this.setState({
           list: data
        });
      }
     });    
  }

  render() {
    const dataSource = this.state.list;
    
    const columns = [{
      title: '订单编号',
      dataIndex: 'item_number',
      key:'item_number',
      className:'th',
      width: 300,
      render: (text, row, index) => {
        const url ="/app/orderDetails/"+row.id;
        return (
          <React.Fragment>
                <a href={url}>{row.order_number}-{row.item_number}</a>
          </React.Fragment>
        );
      }
    }, {
      title: 'SKU名称',
      dataIndex: 'sku_name',
      key:'sku_name',
      className:'th',
      
    }, {
      title: '出发日期',
      dataIndex: 'go_time',
      key:'go_time',
      className:'th',
      width: 200,
    }];

    
    return (
      <React.Fragment>
           <div className="from-email"> 
                   <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1}  dataSource={dataSource} columns={columns} />
           </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    userlist: dispatch.orderDetails.userlist
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Userlist);
